import { Alert, Grid, Typography, useTheme } from "@mui/material"
import logo from "../assets/Orzeon-logo-beeldmerk.png";
import { useTranslation } from "react-i18next";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import React, { useRef } from "react";
import { LoadButton } from "../components/loadButton";
import { useInjection } from "../di/ioc-provider";
import { IUserApiClient } from "../clients/userApiClient";
import { TYPES } from "../di/types";
import Loader from "../components/Loader";
import { AuthStore } from "../stores/AuthStore";
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router";
import { CreateNewAccount } from "../components/createNewAccount";
export const LoginPage = () => {

    const history = useHistory();
    const theme = useTheme();
    var colorBorder = (theme as any).border.primary
    const [t] = useTranslation("common");
    const formRef = useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [magicLinkFailed, setMagicLinkFailed] = React.useState(false);
    const [loginSucceeded, setLoginSucceeded] = React.useState(false);
    const [errorReceived, setErrorReceived] = React.useState(false);
    const [magicLinkCreationSuccess, setMagicLinkCreationSuccess] = React.useState(false);
    const _userApiClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const [magicLink, setMagicLink] = React.useState<string | undefined>(undefined);
    const [noAccountActive, setNoAccountActive] = React.useState(false);

    React.useEffect(() => {
        if (window.location.href.indexOf("#registerUser") != -1) {
            setNoAccountActive(true);
            window.location.href = window.location.href.replace("registerUser", "");
        }
    }, [])

    React.useEffect(() => {
        if (magicLinkFailed) {
            setTimeout(() => {
                setMagicLinkFailed(false);
                setErrorReceived(false);
                setMagicLink(undefined);
            }, 2500)
        }
    }, [magicLinkFailed])

    React.useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        var magicLink = queryParameters.get("magicLink");
        setMagicLink(magicLink);

        if (magicLink != undefined) {
            loginWithMagicLink(magicLink);
        }
    }, [])
    const loginWithMagicLink = (link: string) => {
        _userApiClient.login({ passwordLink: link }).then((res) => {
            setLoginSucceeded(true);
            var info = jwtDecode(res.data) as any;
            var role = false;
            if (info.role != null) {
                role = info.role == "True";
            }
            window.localStorage.setItem('jwt', res.data);

            AuthStore.update(w => { w.authSettings = { jwtToken: res.data, email: info.email, name: info.name, newUser: false, role: role } })

            setTimeout(() => {
                history.push("/")
            }, 1000)
        }).catch((err) => {
            setMagicLinkFailed(true);
        })
    }
    const saveValidate = () => {
        if (formRef != null && formRef.current != null) {
            var testForm = formRef.current as any;
            testForm
                .isFormValid()
                .then((result: boolean) => {
                    if (result) {
                        createMagicLink();
                    }
                })
                .catch((err: any) => { });
        }
    };
    const createMagicLink = () => {
        setLoading(true);
        _userApiClient.sendMagicLink({ email: email }).then((res) => {

            setMagicLinkCreationSuccess(true);
        }).catch((err) => {
            setErrorReceived(true);
        }).finally(() => {
            setLoading(false);
        })
    }
    return <>
        <Grid container justifyContent={"center"} >
            {noAccountActive ? <>
                <Grid item style={{ padding: "54px", paddingTop: "12px", border: `5px solid ${colorBorder}`, borderRadius: "10px", textAlign: "center" }}>
                    <img src={logo}></img>
                    <div style={{ borderRadius: "10px", padding: "26px", background: "rgb(24, 159, 249, 0.4)" }}>
                        <Typography style={{ color: "#276B98" }} variant="body1">{t("login.logintext")}</Typography>

                    </div>
                    <CreateNewAccount onCancel={() => { setNoAccountActive(false) }} />
                </Grid></>
                : <> <Grid item style={{ padding: "54px", paddingTop: "12px", border: `5px solid ${colorBorder}`, borderRadius: "10px", textAlign: "center" }}>
                    <img src={logo}></img>
                    <div style={{ borderRadius: "10px", padding: "26px", background: "rgb(24, 159, 249, 0.4)" }}>
                        <Typography style={{ color: "#276B98" }} variant="body1">{t("login.logintext")}</Typography>

                    </div>
                    {magicLink != undefined ? <>
                        {loginSucceeded ? <>  <Alert sx={{ mt: "4px", mb: "4px" }} severity="success" >{t("login.loginSuccess")}</Alert></> : <></>}
                        {magicLinkFailed ? <><Alert sx={{ mt: "4px", mb: "4px" }} severity="error" >{t("login.loginFailed")}</Alert></> : <></>}
                        {!magicLinkFailed && !loginSucceeded ? <> <Grid container>
                            <Grid item> <Loader /></Grid>
                            <Grid item> <Typography style={{ marginTop: "8px", color: "#276B98" }} variant="body1">{t("login.validatingMagicLink")}</Typography></Grid>
                        </Grid></> : <></>}
                    </> : <>
                        {errorReceived ? <Alert sx={{ mt: "4px", mb: "4px" }} severity="error">{t("login.errorLogin")}</Alert> : null}
                        {magicLinkCreationSuccess ? <>
                            <Alert sx={{ mt: "4px", mb: "4px" }} severity="success" >{t("login.magicLinkSuccess")}</Alert>
                        </> : <>
                            <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
                                <TextValidator

                                    disabled={loading}
                                    margin="normal"

                                    fullWidth
                                    label={t("general.email")}
                                    name="email"
                                    value={email}
                                    autoFocus
                                    validators={["required"]}
                                    errorMessages={[t("validation.required")]}
                                    onChange={(ev) => {
                                        setEmail(ev.target.value);
                                    }}
                                />

                                <LoadButton
                                    style={{ width: "100%", marginTop: "14px" }}
                                    isLoading={loading}
                                    type="submit"
                                    variant="contained"
                                    buttonText={t("general.loginBtn")}
                                    onClick={saveValidate}>

                                </LoadButton>
                                <p onClick={() => { setNoAccountActive(true); }} style={{ color: "rgb(39, 107, 152)", textDecoration: "underline", cursor: "pointer" }}>{t("general.iHaveNoAccount")}</p>
                            </ValidatorForm>
                        </>}
                    </>}
                </Grid></>}
        </Grid>
    </>
}